import React from "react";

export const Input = ({
  placeholder,
  value,
  correct,
  type = "text",
  error,
  getValue,
  id,
  error_text = "error",
  read_only = false,
  max_length = "250",
  onChange,
}) => {
  return (
    <div className="c-input">
      <div className="c-input__content">
        {type == "tel" && (
          <label htmlFor={id} className="phone__code">
            +1
          </label>
        )}
        <input
          type={type}
          placeholder={placeholder}
          value={value}
          id={id}
          onInput={(e) => getValue && getValue(e.target)}
          maxLength={max_length}
          readOnly={read_only}
          className={`${type == "tel" ? "phone" : ""}`}
          onChange={onChange}
        />
        <div className={`c-input__correct ${correct ? "show" : ""}`}>
          <img src="/assets/icons/agree.svg" alt="correct" />
        </div>
      </div>
      {
        error_text && error && (
          <div className={`c-input__error`}>
            {error_text}
          </div>
        )
      }
    </div>
  );
};
